var map = {
	"./branding.bio.jpg": 8454,
	"./mantras.bio.jpg": 678,
	"./meditacion.bio.jpg": 3340,
	"./mindful.bio.jpg": 7068,
	"./pranayamas.bio.jpg": 5119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9978;